import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { throwError } from 'rxjs';

import { ApiError } from '../model/api-error';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class ExceptionService {

  constructor(private loggerService: LoggerService) { }

  public handleError(error: HttpErrorResponse) {
    let apiError: ApiError = new ApiError();
    try {
      if (error.error instanceof ErrorEvent) {
        apiError.message = error?.error?.message || 'Something went wrong!';
      } else {
        console.error(`Backend returned code ${error.status}, body was:`, error.error);
        let body = error.error;
        if (typeof body === 'string') {
          try { body = JSON.parse(body); } catch { /* keep as string */ }
        }
        if (body && typeof body === 'object' && body.message) {
          apiError.message = body.message;
        } else if (typeof body === 'string' && body.trim()) {
          apiError.message = body.trim();
        } else {
          apiError.message = 'Server exception. Please contact College Admin helpdesk.';
        }
      }
    } catch {
      apiError.message = 'An unexpected error occurred.';
    }
    return throwError(() => apiError);
  }

}
